// DEV API BASE URL
// var api = "https://guinaw-warc.withvolkeno.com/api/";

// PROD API BASE URL
var api = 'https://www.back.warcfulbright.org/api/'
export const ApiUrl = api;
export default api;
